import { IconInfoCircle as TablerIconInfoCircle } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconInfoCircle = /*#__PURE__*/ createOutlineIcon(
  TablerIconInfoCircle,
  'IconInfoCircle',
);
